import { useTranslation } from 'react-i18next';
import classnames from 'classnames/bind';
import * as styles from './WarehouseLoadDialog.css';

const cx = classnames.bind(styles);

export function NotAvailable() {
    const { t } = useTranslation('common');
    return <span className={cx('not-available')}>{t('naDashes')}</span>;
}
